export default __webpack_public_path__ + "static/media/Institution.a604d91a.png";